import {createFileRoute} from "@tanstack/react-router";
import {TemplatePage} from "~/modules/templateDefinitions/page";
import {templateSearchSchema} from "~/modules/templateDefinitions/model";
export const Route = createFileRoute("/_withAuthenticationStatus/_authenticated/_withProfileStatus/_profileCompleted/a/_adminScaffold/data-cluster-templates")({
    validateSearch: templateSearchSchema,
    loader: ({context}) => ({accessToken: context.authenticationStatus.accessToken, intellsysBaseUrl: context.intellsysBaseUrl}),
    component: Page,
});
function Page() {
    const context = Route.useLoaderData();
    const {mode, id} = Route.useSearch();
    return (
        <TemplatePage
            context={context}
            kind="data-cluster-templates"
            mode={mode}
            id={id}
        />
    );
}
